module.exports = __webpack_public_path__ + "img/homeimage2.ce6391c0.webp";